import React, { useEffect, useRef, useState } from "react";
import { HiOutlineGlobeAlt, HiOutlineChevronDown } from "react-icons/hi2";

const SCRIPT_ID = "google-translate-script";

const UseGoogleTranslate = () => {
    const pollRef = useRef(null);
    const [widgetReady, setWidgetReady] = useState(false);

    useEffect(() => {
        if (typeof window === "undefined") return;

        if (!window.googleTranslateElementInit) {
            window.googleTranslateElementInit = () => {
                try {
                    // eslint-disable-next-line no-undef
                    new window.google.translate.TranslateElement(
                        { pageLanguage: "en", autoDisplay: false },
                        "google_translate_element"
                    );
                } catch (err) {
                    // ignore silently
                }
            };
        }

        if (!document.getElementById(SCRIPT_ID)) {
            const script = document.createElement("script");
            script.id = SCRIPT_ID;
            script.src =
                "https://translate.google.com/translate_a/element.js?cb=googleTranslateElementInit";
            script.async = true;
            script.defer = true;
            document.body.appendChild(script);
        }

        const waitForCombo = () => {
            const combo = document.querySelector(".goog-te-combo");
            if (combo) {
                setWidgetReady(true);
                if (pollRef.current) {
                    clearInterval(pollRef.current);
                    pollRef.current = null;
                }
            }
        };

        pollRef.current = setInterval(waitForCombo, 300);
        waitForCombo();

        return () => {
            if (pollRef.current) {
                clearInterval(pollRef.current);
                pollRef.current = null;
            }
        };
    }, []);

    const dispatchChange = (el) => {
        if (!el) return;
        const evt = new Event("change", { bubbles: true });
        el.dispatchEvent(evt);
    };

    const changeLanguage = (lang) => {
        const selectElement = document.querySelector(".goog-te-combo");
        if (!selectElement) {
            console.warn("Google Translate widget not ready");
            return;
        }

        const currentLang = selectElement.value || "";

        if (lang === "") {
            selectElement.value = "en";
            dispatchChange(selectElement);
            return;
        }

        if (currentLang === lang) {
            selectElement.value = "en";
            dispatchChange(selectElement);
            setTimeout(() => {
                selectElement.value = lang;
                dispatchChange(selectElement);
            }, 250);
        } else {
            selectElement.value = lang;
            dispatchChange(selectElement);
        }
    };

    return (
        <div className="d-flex align-items-center gap-3 flex-wrap">
            {/* Icon */}
            <HiOutlineGlobeAlt className="text-primary fs-4" />

            {/* Select dropdown */}
            <div className="position-relative">
                <select
                    defaultValue=""
                    onChange={(e) => changeLanguage(e.target.value)}
                    className="form-select pe-5"
                    style={{ minWidth: "180px" }}
                >
                    <option value="">Select Language</option>
                    <option value="en">English</option>
                    <option value="hi">हिन्दी</option>
                    <option value="mr">मराठी</option>
                </select>

                {/* Chevron icon */}
                <HiOutlineChevronDown
                    className="position-absolute text-secondary"
                    style={{
                        right: "10px",
                        top: "50%",
                        transform: "translateY(-50%)",
                        pointerEvents: "none",
                    }}
                />
            </div>

            {/* Hidden element for Google widget */}
            <div id="google_translate_element" style={{ display: "none" }} />

            {/* Status text */}
            <div className="ms-2 small">
                {widgetReady ? (
                    <span className="text-success">Translator ready</span>
                ) : (
                    <span className="text-muted">Loading translator…</span>
                )}
            </div>
        </div>
    );
};

export default UseGoogleTranslate;
